import { categoriasPet } from '../../helpers/funcoesAuxiliares';

export const verificarExcecaoPetPorLocalidade = (categoria,parentesco) => categoriasPet.includes(categoria) && parentesco === 'PET';